import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Modal } from "@/components/erp/ui";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

// Grafik harga beli per PO untuk satu item stok
export const PriceHistory = ({ item, onClose }) => {
  const [d, setD] = useState(null);
  useEffect(() => { if (item) { setD(null); api.get(`/stock/${item.id}/price-history`).then(({ data }) => setD(data)).catch(() => setD({ rows: [] })); } else { setD(null); } }, [item]);
  const rows = d?.rows || [];
  const first = rows[0]?.unit_price; const last = rows[rows.length - 1]?.unit_price;
  const total = first && rows.length > 1 ? Math.round(((last - first) * 1000) / first) / 10 : null;
  return (
    <Modal open={!!item} onClose={onClose} wide title={`Riwayat harga beli · ${item?.name || ""}${item?.variant ? ` (${item.variant})` : ""}${item?.brand ? ` · ${item.brand}` : ""}`}>
      {!d ? <p className="text-sm text-slate-400">Memuat…</p> : !rows.length ? <p className="text-sm text-slate-500" data-testid="ph-empty">Belum ada PO untuk item ini. Harga sekarang {formatIDR(item?.cost || 0)} (manual / stok lama).</p> : (
        <div data-testid="price-history">
          <div className="flex flex-wrap gap-4 text-sm mb-2">
            <span>PO pertama <b>{formatIDR(first)}</b></span><span>Terbaru <b>{formatIDR(last)}</b></span>
            {total != null && <span data-testid="ph-total" className={total > 0 ? "text-rose-600 font-semibold" : total < 0 ? "text-emerald-600 font-semibold" : ""}>{total > 0 ? "▲" : total < 0 ? "▼" : ""} {total}% sejak PO pertama</span>}
          </div>
          <div className="h-56"><ResponsiveContainer width="100%" height="100%">
            <LineChart data={rows} margin={{ left: 10, right: 10, top: 10 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} tickFormatter={(v) => (v >= 1000 ? `${Math.round(v / 1000)}rb` : v)} width={44} />
              <Tooltip formatter={(v) => formatIDR(v)} labelFormatter={(l, p) => `${l} · ${p?.[0]?.payload?.code || ""}`} />
              <Line type="monotone" dataKey="unit_price" stroke="#0f766e" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer></div>
          <table className="w-full text-xs mt-3">
            <thead className="text-slate-500 bg-slate-50"><tr><th className="p-2 text-left">Tanggal</th><th className="p-2 text-left">PO</th><th className="p-2 text-left">Supplier</th><th className="p-2 text-right">Qty</th><th className="p-2 text-right">Harga satuan</th><th className="p-2 text-right">Perubahan</th></tr></thead>
            <tbody>{[...rows].reverse().map((r) => (
              <tr key={r.code} className="border-t border-slate-100" data-testid={`ph-row-${r.code}`}>
                <td className="p-2">{r.date}</td><td className="p-2 font-mono">{r.code}</td><td className="p-2">{r.supplier || "—"}</td><td className="p-2 text-right">{r.qty}</td>
                <td className="p-2 text-right font-semibold">{formatIDR(r.unit_price)}</td>
                <td className={`p-2 text-right ${r.change_pct > 0 ? "text-rose-600" : r.change_pct < 0 ? "text-emerald-600" : "text-slate-400"}`}>{r.change_pct == null ? "—" : `${r.change_pct > 0 ? "+" : ""}${r.change_pct}%`}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </Modal>
  );
};
